import React, { useState } from 'react';
import './App.css';
import { SEOHead } from './components/SEOHead';
import { HeroRotating } from './HeroRotating';
// import { ScrollingMarquee } from './ScrollingMarquee';
// import { ThreeFeatures } from './ThreeFeatures';
import { HowItWorksJourney } from './HowItWorksJourney';
// import { WhatYouGetVisual } from './WhatYouGetVisual';
import { CredibilitySection } from './CredibilitySection';
// import { RealStories } from './RealStories';
import { PressLogos } from './PressLogos';
import { FAQ } from './FAQ';
import { Footer } from './Footer';
// import { VideoStories } from './VideoStories';
import { StatsSection } from './StatsSection';
// import { PatientSpotlight } from './PatientSpotlight';
import { FoundersSection } from './FoundersSection';
import { ConditionsTicker } from './ConditionsTicker';
// import { TrustSection } from './TrustSection';
import { TrustCenter } from './TrustCenter';
import { QuizExperience } from './QuizExperience';
import { PatientStories } from './PatientStories';
import { BlogArticle } from './BlogArticle';
import { ArticlesLanding } from './ArticlesLanding';
import { ConditionArticles } from './ConditionArticles';
import { AboutApproach } from './AboutApproach';
import { SignUp } from './SignUp';
import { OpportunitiesPreview } from './OpportunitiesPreview';
import { NotFound } from './NotFound';
import { PatientSignupFlow } from './prototypes/signup/PatientSignupFlow';
import { OpportunityFlow } from './prototypes/opportunity/OpportunityFlow';
import { ValueFirstFlow } from './prototypes/value-first/ValueFirstFlow';
import { OurStory } from './OurStory';
import { Header } from './Header';
import { WeMovedPage } from './WeMovedPage';
import { PatientJourneyExperience } from './components/PatientJourneyExperience';
// import { WaveDivider } from './components/WaveDivider';
import { PartnersLanding } from './PartnersLanding';
import { PrivacyPolicy } from './PrivacyPolicy';
import { TermsOfService } from './TermsOfService';
import { RequestProject } from './RequestProject';
import { PatientIntel } from './patientintel/PatientIntel';
import { EngagementPage } from './engagement/EngagementPage';
import { GSK } from './gsk/GSK';
import { StudyPage } from './StudyPage';
import { DemoPage } from './DemoPage';
import { narcolepsyArticles } from './narcolepsyArticlesData';
import { lupusArticles } from './lupusArticlesData';
import { getQuestionsForCondition, getAnswersForQuestion } from './prototypes/reflect/reflectData';

// Maps article categories to the most relevant Reflect question index for that condition
const CATEGORY_TO_QUESTION_INDEX = {
  'Living with Lupus': 0,
  'Symptom Management': 1,
  'Mental Health': 1,
  'Treatment': 3,
  'Nutrition': 1,
  'Work & Life': 2,
  'Complications': 1,
  'Healthcare': 1,
  'Lupus': 0,
  'Narcolepsy': 0,
  'Polycythemia Vera': 0,
};

const getCommunityDataForArticle = (condition, articleCategory) => {
  const questions = getQuestionsForCondition(condition);
  if (!questions.length) return { question: null, answers: [] };
  const idx = CATEGORY_TO_QUESTION_INDEX[articleCategory] ?? 0;
  const q = questions[Math.min(idx, questions.length - 1)];
  return { question: q.question, answers: getAnswersForQuestion(q.id) };
};

// Temporary rebrand banner - Remove after 30-60 days post-launch (target: mid-February 2026)
const BANNER_HEIGHT_DESKTOP = 64;
const BANNER_HEIGHT_MOBILE = 150;

const RebrandBanner = ({ onLearnMore, onDismiss, dismissed }) => {
  if (dismissed) return null;

  return (
    <>
      <style>{`
        .rebrand-banner {
          min-height: ${BANNER_HEIGHT_DESKTOP}px;
          height: auto;
        }
        .rebrand-banner-content {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          gap: 8px;
        }
        .rebrand-learn-more {
          margin-left: 8px;
          min-height: 44px;
          min-width: 44px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }
        .rebrand-dismiss {
          min-height: 44px;
          min-width: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        @media (max-width: 600px) {
          .rebrand-banner {
            min-height: ${BANNER_HEIGHT_MOBILE}px;
            padding: 12px 48px 12px 16px !important;
          }
          .rebrand-banner-content {
            justify-content: center;
            text-align: center;
          }
          .rebrand-learn-more {
            margin-left: 0;
            margin-top: 6px;
            width: 100%;
            display: flex;
          }
          .rebrand-dismiss {
            right: 4px !important;
            top: 4px !important;
          }
        }
      `}</style>
      <div
        className="rebrand-banner"
        style={{
          backgroundColor: '#272726',
          color: '#fff',
          padding: '12px 20px',
          textAlign: 'center',
          fontSize: '14px',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1001,
          boxSizing: 'border-box'
        }}
      >
        <div className="rebrand-banner-content">
          <span>
            <span style={{ marginRight: '8px' }}>✨</span>
            <strong>Savvy Cooperative is now Real Patients.</strong>
            <span style={{ color: 'rgba(255,255,255,0.8)', marginLeft: '8px' }}>
              Same mission, new name.
            </span>
          </span>
          <button
            onClick={onLearnMore}
            className="rebrand-learn-more"
            style={{
              background: '#fff',
              border: 'none',
              color: '#272726',
              padding: '10px 16px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '13px',
              fontWeight: '600',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'rgba(255,255,255,0.85)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#fff';
            }}
          >
            Learn more →
          </button>
        </div>
        <button
          onClick={onDismiss}
          className="rebrand-dismiss"
          style={{
            position: 'absolute',
            right: '8px',
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'none',
            border: 'none',
            color: 'rgba(255,255,255,0.5)',
            cursor: 'pointer',
            fontSize: '20px',
            padding: '8px',
            lineHeight: 1
          }}
          aria-label="Dismiss banner"
        >
          ×
        </button>
      </div>
    </>
  );
};

// Condition data with colors (no emojis for cleaner design)
const conditionsData = {
  Lupus: { color: '#9b59b6' },
  Narcolepsy: { color: '#385cbc' },
  'Polycythemia Vera': { color: '#f15b41' }
};

// Articles by condition
const articlesByCondition = {
  Lupus: [
    {
      id: 'lupus-2025-treatment-guidelines',
      title: 'The 2025 Lupus Treatment Guidelines: What Real Patients Want You to Know',
      excerpt: 'The ACR just released new guidelines for treating lupus—emphasizing you\'re an equal partner in your care. We asked real patients what treatment decisions actually feel like.',
      readTime: '10 min',
      date: 'Jan 24, 2025',
      category: 'Treatment',
      featured: true,
      hasFullArticle: true
    },
    {
      id: 1,
      title: 'Can You Die From Lupus? What 650 Real Patients Want You to Know',
      excerpt: 'The question haunts nearly every lupus patient at some point: Can this disease kill me? We asked 650 real lupus patients about their fears, experiences, and what they wish they\'d known.',
      readTime: '8 min',
      date: 'Jan 20, 2025',
      category: 'Living with Lupus',
      featured: false
    },
    {
      id: 2,
      title: 'Understanding Lupus Flares: Triggers, Symptoms, and Management',
      excerpt: 'Learn what causes lupus flares, how to recognize early warning signs, and strategies real patients use to manage them.',
      readTime: '6 min',
      date: 'Jan 18, 2025',
      category: 'Symptom Management'
    },
    {
      id: 3,
      title: 'The Lupus Diet: What Patients Say Actually Works',
      excerpt: 'We surveyed hundreds of lupus patients about dietary changes. Here\'s what they found helpful.',
      readTime: '7 min',
      date: 'Jan 15, 2025',
      category: 'Nutrition'
    },
    {
      id: 4,
      title: 'Lupus and Mental Health: Breaking the Silence',
      excerpt: 'Depression, anxiety, and brain fog affect many lupus patients. Real stories of coping and finding support.',
      readTime: '9 min',
      date: 'Jan 12, 2025',
      category: 'Mental Health'
    },
    {
      id: 5,
      title: 'Navigating Lupus Treatment Options in 2025',
      excerpt: 'From Plaquenil to biologics like Saphnelo and Benlysta—what patients are saying about their treatment journeys.',
      readTime: '11 min',
      date: 'Jan 10, 2025',
      category: 'Treatment'
    },
    {
      id: 6,
      title: 'Working with Lupus: Career Strategies from Real Patients',
      excerpt: 'How patients balance careers with chronic illness, including tips for workplace accommodations.',
      readTime: '6 min',
      date: 'Jan 8, 2025',
      category: 'Work & Life'
    },
    {
      id: 7,
      title: 'Lupus Nephritis: What Every Patient Should Know',
      excerpt: 'Kidney involvement is one of the most serious lupus complications. Here\'s what patients learned.',
      readTime: '8 min',
      date: 'Jan 5, 2025',
      category: 'Complications'
    },
    {
      id: 8,
      title: 'Finding the Right Rheumatologist: Patient Tips',
      excerpt: 'What to look for, questions to ask, and red flags according to experienced lupus patients.',
      readTime: '5 min',
      date: 'Jan 3, 2025',
      category: 'Healthcare'
    }
  ],
  Narcolepsy: [
    {
      id: 'nt1-diagnosis-journey',
      title: 'Why Does It Take 10 Years to Get Diagnosed with Narcolepsy?',
      excerpt: 'The average narcolepsy patient waits over a decade for answers. We surveyed 128 people with Narcolepsy Type 1 about their diagnostic journeys.',
      readTime: '9 min',
      date: 'Jan 22, 2025',
      category: 'Diagnosis',
      featured: true,
      hasFullArticle: true
    },
    {
      id: 'nt1-not-laziness',
      title: "It's Not Laziness: What Narcolepsy Sleepiness Really Feels Like",
      excerpt: 'Everyone gets tired. But narcolepsy exhaustion is fundamentally different—and far too often dismissed as laziness.',
      readTime: '8 min',
      date: 'Jan 20, 2025',
      category: 'Living with Narcolepsy',
      hasFullArticle: true
    },
    {
      id: 'nt1-cataplexy',
      title: 'Cataplexy Explained: When Emotions Make Your Body Collapse',
      excerpt: 'Imagine laughing at a joke and your knees buckling. For people with Narcolepsy Type 1, cataplexy turns emotions into physical vulnerability.',
      readTime: '7 min',
      date: 'Jan 18, 2025',
      category: 'Symptoms',
      hasFullArticle: true
    },
    {
      id: 'nt1-medications-2025',
      title: 'Narcolepsy Medications: What 128 Patients Say About Their Treatments',
      excerpt: 'From sodium oxybate to stimulants to the newest wake-promoting agents—what actually works?',
      readTime: '10 min',
      date: 'Jan 15, 2025',
      category: 'Treatment',
      hasFullArticle: true
    },
    {
      id: 'nt1-driving-safety',
      title: 'Is It Safe to Drive with Narcolepsy? What Patients Have Learned',
      excerpt: 'Driving with narcolepsy is one of the most anxiety-producing topics patients face.',
      readTime: '7 min',
      date: 'Jan 12, 2025',
      category: 'Daily Life',
      hasFullArticle: true
    },
    {
      id: 6,
      title: 'Narcolepsy at Work: Disclosure, Accommodations, and Career Success',
      excerpt: 'Should you tell your employer? What accommodations help? Patients share their workplace experiences.',
      readTime: '8 min',
      date: 'Jan 7, 2025',
      category: 'Work & Life'
    },
    {
      id: 7,
      title: 'Sleep Paralysis and Hallucinations: The Scary Side of Narcolepsy',
      excerpt: 'These often-undiscussed symptoms can be terrifying. Patients share their experiences and coping strategies.',
      readTime: '6 min',
      date: 'Jan 4, 2025',
      category: 'Symptoms'
    },
    {
      id: 8,
      title: 'Finding Community: Narcolepsy Support Groups That Help',
      excerpt: 'Connecting with others who understand can be life-changing. Patients recommend their favorite resources.',
      readTime: '4 min',
      date: 'Jan 1, 2025',
      category: 'Support'
    }
  ],
  'Polycythemia Vera': [
    {
      id: 1,
      title: 'Polycythemia Vera: What 300 Patients Wish They Knew at Diagnosis',
      excerpt: 'A rare blood cancer that many have never heard of. Real patients share what they\'ve learned living with PV.',
      readTime: '10 min',
      date: 'Jan 21, 2025',
      category: 'Living with PV',
      featured: true
    },
    {
      id: 2,
      title: 'Phlebotomy Life: Managing Regular Blood Draws',
      excerpt: 'For many PV patients, frequent phlebotomy is the first line of treatment. Here\'s what to expect.',
      readTime: '6 min',
      date: 'Jan 18, 2025',
      category: 'Treatment'
    },
    {
      id: 3,
      title: 'The Itch That Won\'t Quit: Aquagenic Pruritus in PV',
      excerpt: 'That maddening itch after showers or swimming affects many PV patients. Learn coping strategies that help.',
      readTime: '5 min',
      date: 'Jan 15, 2025',
      category: 'Symptoms'
    },
    {
      id: 4,
      title: 'Hydroxyurea vs. Jakafi: Patient Experiences with PV Medications',
      excerpt: 'Two common treatment paths with different trade-offs. Real patients compare their experiences.',
      readTime: '9 min',
      date: 'Jan 12, 2025',
      category: 'Treatment'
    },
    {
      id: 5,
      title: 'Blood Clots and PV: Understanding Your Risk',
      excerpt: 'Clotting is a serious concern for PV patients. Learn about prevention and warning signs from those who\'ve been there.',
      readTime: '8 min',
      date: 'Jan 9, 2025',
      category: 'Complications'
    },
    {
      id: 6,
      title: 'Fatigue in Polycythemia Vera: It\'s Not Just Being Tired',
      excerpt: 'Despite having too many red blood cells, crushing fatigue is common. Patients share what helps.',
      readTime: '6 min',
      date: 'Jan 6, 2025',
      category: 'Symptoms'
    },
    {
      id: 7,
      title: 'PV and Progression: What Patients Need to Know',
      excerpt: 'Understanding the risk of progression to myelofibrosis or AML—without panic. Real perspectives from patients.',
      readTime: '11 min',
      date: 'Jan 3, 2025',
      category: 'Prognosis'
    },
    {
      id: 8,
      title: 'Finding a Hematologist Who Knows MPNs',
      excerpt: 'PV is rare, and not all hematologists have experience with it. Tips for finding the right specialist.',
      readTime: '5 min',
      date: 'Dec 30, 2024',
      category: 'Healthcare'
    }
  ]
};

function App() {
  const [showQuiz, setShowQuiz] = useState(false);
  const [showPatientStories, setShowPatientStories] = useState(false);
  const [showBlogTemplate, setShowBlogTemplate] = useState(false);
  const [showArticles, setShowArticles] = useState(false);
  const [showAboutApproach, setShowAboutApproach] = useState(false);
  const [showSignUp, setShowSignUp] = useState(false);
  const [showOpportunities, setShowOpportunities] = useState(false);
  const [selectedStudy, setSelectedStudy] = useState(null);
  const [show404, setShow404] = useState(false);
  const [showOurStory, setShowOurStory] = useState(false);
  const [showTrustCenter, setShowTrustCenter] = useState(false);
  const [showMoved, setShowMoved] = useState(false);
  const [showPatientJourneys, setShowPatientJourneys] = useState(false);
  const [showPartners, setShowPartners] = useState(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [showTermsOfService, setShowTermsOfService] = useState(false);
  const [showRequestProject, setShowRequestProject] = useState(false);
  const [showPrototypeSignup, setShowPrototypeSignup] = useState(false);
  const [showPrototypeOpportunity, setShowPrototypeOpportunity] = useState(false);
  const [showPrototypeValueFirst, setShowPrototypeValueFirst] = useState(false);
  const [showPatientIntel, setShowPatientIntel] = useState(false);
  const [showEngagement, setShowEngagement] = useState(false);
  const [showGSK, setShowGSK] = useState(false);
  const [showNsclcStudy, setShowNsclcStudy] = useState(false);
  const [showDemo, setShowDemo] = useState(false);
  const [selectedCondition, setSelectedCondition] = useState(null);
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [bannerDismissed, setBannerDismissed] = useState(() => {
    return sessionStorage.getItem('rebrandBannerDismissed') === 'true';
  });
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleBannerDismiss = () => {
    setBannerDismissed(true);
    sessionStorage.setItem('rebrandBannerDismissed', 'true');
  };

  const bannerHeight = isMobile ? BANNER_HEIGHT_MOBILE : BANNER_HEIGHT_DESKTOP;
  const bannerOffset = bannerDismissed ? 0 : bannerHeight;

  // Helper to update URL without reload
  const updateURL = (path) => {
    window.history.pushState({}, '', path);
  };

  // Check URL pathname on initial load
  React.useEffect(() => {
    const pathname = window.location.pathname;

    // Route based on pathname
    if (pathname === '/signup' || pathname === '/sign-up') {
      window.location.href = 'https://share.realpatients.com/register/';
      return;
    } else if (pathname === '/our-story') {
      setShowOurStory(true);
    } else if (pathname === '/trust-center' || pathname === '/trust') {
      setShowTrustCenter(true);
    } else if (pathname === '/quiz') {
      setShowQuiz(true);
    } else if (pathname === '/articles') {
      setShowArticles(true);
    } else if (pathname === '/patient-stories' || pathname === '/stories') {
      setShowPatientStories(true);
    } else if (pathname === '/about' || pathname === '/our-story') {
      setShowOurStory(true);
    } else if (pathname === '/opportunities') {
      setShowOpportunities(true);
    } else if (pathname === '/moved') {
      setShowMoved(true);
    } else if (pathname === '/patient-journeys') {
      setShowPatientJourneys(true);
    } else if (pathname === '/partners') {
      setShowPartners(true);
    } else if (pathname === '/privacy' || pathname === '/privacy-policy') {
      setShowPrivacyPolicy(true);
    } else if (pathname === '/terms' || pathname === '/terms-of-service') {
      setShowTermsOfService(true);
    } else if (pathname === '/request-project') {
      setShowRequestProject(true);
    } else if (pathname === '/prototype/signup') {
      setShowPrototypeSignup(true);
    } else if (pathname === '/prototype/opportunity') {
      setShowPrototypeOpportunity(true);
    } else if (pathname === '/prototype/value-first') {
      setShowPrototypeValueFirst(true);
    } else if (pathname === '/intelligence') {
      setShowPatientIntel(true);
    } else if (pathname === '/engagement') {
      setShowEngagement(true);
    } else if (pathname === '/gsk' || pathname === '/g052026') {
      setShowGSK(true);
    } else if (pathname === '/nsclc') {
      setShowNsclcStudy(true);
    } else if (pathname === '/demo') {
      setShowDemo(true);
    } else if (pathname === '/404' || window.location.search.includes('404')) {
      setShow404(true);
    } else if (pathname.startsWith('/condition/')) {
      const pathParts = pathname.replace('/condition/', '').split('/');
      const condition = decodeURIComponent(pathParts[0]);
      const articleId = pathParts[1] ? decodeURIComponent(pathParts[1]) : null;

      if (conditionsData[condition]) {
        if (articleId) {
          // Find the article in the condition's articles
          const conditionArticles = articlesByCondition[condition] || [];
          const article = conditionArticles.find(a => a.id === articleId || a.id === parseInt(articleId));
          if (article) {
            setSelectedArticle({ ...article, condition: condition });
          } else {
            setSelectedCondition(condition);
          }
        } else {
          setSelectedCondition(condition);
        }
      }
    }

    // Handle browser back/forward buttons
    const handlePopState = () => {
      const path = window.location.pathname;
      resetViewsInternal();

      if (path === '/signup' || path === '/sign-up') {
        window.location.href = 'https://share.realpatients.com/register/';
        return;
      } else if (path === '/our-story') {
        setShowOurStory(true);
      } else if (path === '/trust-center' || path === '/trust') {
        setShowTrustCenter(true);
      } else if (path === '/quiz') {
        setShowQuiz(true);
      } else if (path === '/articles') {
        setShowArticles(true);
      } else if (path === '/patient-stories' || path === '/stories') {
        setShowPatientStories(true);
      } else if (path === '/about' || path === '/our-story') {
        setShowOurStory(true);
      } else if (path === '/opportunities') {
        setShowOpportunities(true);
      } else if (path === '/patient-journeys') {
        setShowPatientJourneys(true);
      } else if (path === '/partners') {
        setShowPartners(true);
      } else if (path === '/privacy' || path === '/privacy-policy') {
        setShowPrivacyPolicy(true);
      } else if (path === '/terms' || path === '/terms-of-service') {
        setShowTermsOfService(true);
      } else if (path === '/request-project') {
        setShowRequestProject(true);
      } else if (path === '/intelligence') {
        setShowPatientIntel(true);
      } else if (path === '/engagement') {
        setShowEngagement(true);
      } else if (path === '/gsk' || path === '/g052026') {
        setShowGSK(true);
      } else if (path === '/nsclc') {
        setShowNsclcStudy(true);
      } else if (path === '/demo') {
        setShowDemo(true);
      } else if (path.startsWith('/condition/')) {
        const pathParts = path.replace('/condition/', '').split('/');
        const condition = decodeURIComponent(pathParts[0]);
        const articleId = pathParts[1] ? decodeURIComponent(pathParts[1]) : null;

        if (conditionsData[condition]) {
          if (articleId) {
            const conditionArticles = articlesByCondition[condition] || [];
            const article = conditionArticles.find(a => a.id === articleId || a.id === parseInt(articleId));
            if (article) {
              setSelectedArticle({ ...article, condition: condition });
            } else {
              setSelectedCondition(condition);
            }
          } else {
            setSelectedCondition(condition);
          }
        }
      }
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  // Internal reset without URL update
  const resetViewsInternal = () => {
    setShowQuiz(false);
    setShowPatientStories(false);
    setShowBlogTemplate(false);
    setShowArticles(false);
    setShowAboutApproach(false);
    setShowSignUp(false);
    setShowOpportunities(false);
    setShow404(false);
    setShowOurStory(false);
    setShowTrustCenter(false);
    setShowMoved(false);
    setShowPatientJourneys(false);
    setShowPartners(false);
    setShowPrivacyPolicy(false);
    setShowTermsOfService(false);
    setShowRequestProject(false);
    setShowPrototypeSignup(false);
    setShowPrototypeOpportunity(false);
    setShowPrototypeValueFirst(false);
    setShowPatientIntel(false);
    setShowEngagement(false);
    setShowGSK(false);
    setShowNsclcStudy(false);
    setShowDemo(false);
    setSelectedStudy(null);
    setSelectedCondition(null);
    setSelectedArticle(null);
  };

  // Scroll to top whenever view changes
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [showQuiz, showPatientStories, showBlogTemplate, showArticles, showAboutApproach, showSignUp, showOpportunities, show404, showOurStory, showTrustCenter, showMoved, showPatientJourneys, showPartners, showPrivacyPolicy, showTermsOfService, showRequestProject, showPrototypeSignup, showPrototypeOpportunity, showPrototypeValueFirst, showPatientIntel, showEngagement, showGSK, showDemo, selectedCondition, selectedArticle]);

  // Helper to reset all views and go to a specific one
  const resetViews = () => {
    resetViewsInternal();
    updateURL('/');
  };

  // Common footer props with URL updates
  const footerProps = {
    onHomeClick: () => { resetViewsInternal(); updateURL('/'); },
    onArticlesClick: () => { resetViewsInternal(); setShowArticles(true); updateURL('/articles'); },
    onConditionClick: (condition) => { resetViewsInternal(); setSelectedCondition(condition); updateURL(`/condition/${encodeURIComponent(condition)}`); },
    onPatientStoriesClick: () => { resetViewsInternal(); setShowPatientStories(true); updateURL('/patient-stories'); },
    onQuizClick: () => { resetViewsInternal(); setShowQuiz(true); updateURL('/quiz'); },
    onSignUpClick: () => { window.location.href = 'https://share.realpatients.com/register/'; },
    onAboutClick: () => { resetViewsInternal(); setShowOurStory(true); updateURL('/our-story'); },
    onOurStoryClick: () => { resetViewsInternal(); setShowOurStory(true); updateURL('/our-story'); },
    onTrustCenterClick: () => { resetViewsInternal(); setShowTrustCenter(true); updateURL('/trust-center'); },
    onPatientJourneysClick: () => { resetViewsInternal(); setShowPatientJourneys(true); updateURL('/patient-journeys'); },
    onPartnersClick: () => { resetViewsInternal(); setShowPartners(true); updateURL('/partners'); },
    onPrivacyClick: () => { resetViewsInternal(); setShowPrivacyPolicy(true); updateURL('/privacy'); },
    onTermsClick: () => { resetViewsInternal(); setShowTermsOfService(true); updateURL('/terms'); },
    onRequestProjectClick: () => { resetViewsInternal(); setShowRequestProject(true); updateURL('/request-project'); },
    onCommunityClick: () => { resetViewsInternal(); setShowPrototypeValueFirst(true); updateURL('/prototype/value-first'); }
  };

  // Sign Up Page
  if (showSignUp) {
    return (
      <div className="App">
        <SignUp onBack={() => { setShowSignUp(false); updateURL('/'); }} />
      </div>
    );
  }

  // 404 Page (for preview - access via ?404 in URL or keyboard shortcut)
  if (show404) {
    return (
      <div className="App">
        <NotFound onHomeClick={() => resetViews()} />
      </div>
    );
  }

  // Our Story Page
  if (showOurStory) {
    return (
      <div className="App">
        <RebrandBanner
          onLearnMore={() => {}}
          onDismiss={handleBannerDismiss}
          dismissed={bannerDismissed}
        />
        <OurStory
          headerProps={{
            onLogoClick: () => { resetViewsInternal(); updateURL('/'); },
            onArticlesClick: () => { resetViewsInternal(); setShowArticles(true); updateURL('/articles'); },
            onPatientStoriesClick: () => { resetViewsInternal(); setShowPatientStories(true); updateURL('/patient-stories'); },
            onSignUpClick: () => { window.location.href = 'https://share.realpatients.com/register/'; },
            onAboutClick: () => { resetViewsInternal(); setShowOurStory(true); updateURL('/our-story'); },
            onPartnersClick: () => { resetViewsInternal(); setShowPartners(true); updateURL('/partners'); },
            bannerOffset: bannerOffset
          }}
          footerProps={footerProps}
          bannerOffset={bannerOffset}
        />
      </div>
    );
  }

  // Trust Center Page
  if (showTrustCenter) {
    return (
      <div className="App">
        <TrustCenter
          onBackClick={() => { setShowTrustCenter(false); updateURL('/'); }}
        />
      </div>
    );
  }

  // Opportunities Preview Page
  if (showOpportunities) {
    return (
      <div className="App">
        <Header
          onLogoClick={() => { resetViewsInternal(); updateURL('/'); }}
          onArticlesClick={() => { resetViewsInternal(); setShowArticles(true); updateURL('/articles'); }}
          onPatientStoriesClick={() => { resetViewsInternal(); setShowPatientStories(true); updateURL('/patient-stories'); }}
          onSignUpClick={() => { window.location.href = 'https://share.realpatients.com/register/'; }}
          onCommunityClick={() => { resetViewsInternal(); setShowPrototypeValueFirst(true); updateURL('/prototype/value-first'); }}
          onAboutClick={() => { resetViewsInternal(); setShowOurStory(true); updateURL('/our-story'); }}
        />
        <OpportunitiesPreview
          onBack={() => { resetViewsInternal(); updateURL('/'); }}
          onSignUp={() => { window.location.href = 'https://share.realpatients.com/register/'; }}
          onApply={(study) => {
            resetViewsInternal();
            setSelectedStudy(study);
            setShowPrototypeOpportunity(true);
            updateURL('/prototype/opportunity');
          }}
        />
        <Footer {...footerProps} />
      </div>
    );
  }

  // We've Moved Page (Preview for savvy.coop redirect)
  if (showMoved) {
    return <WeMovedPage />;
  }

  // Patient Journey Experience
  if (showPatientJourneys) {
    return (
      <PatientJourneyExperience
        onClose={() => { setShowPatientJourneys(false); updateURL('/'); }}
      />
    );
  }

  // Partners Landing Page
  if (showPartners) {
    return (
      <div className="App">
        <RebrandBanner
          onLearnMore={() => { setShowPartners(false); setShowOurStory(true); updateURL('/our-story'); }}
          onDismiss={handleBannerDismiss}
          dismissed={bannerDismissed}
        />
        <PartnersLanding
          onBackClick={() => { setShowPartners(false); updateURL('/'); }}
          onContactClick={() => {}}
          onOurStoryClick={() => { setShowPartners(false); setShowOurStory(true); updateURL('/our-story'); }}
          onPrivacyClick={() => { setShowPartners(false); setShowPrivacyPolicy(true); updateURL('/privacy'); }}
          onTermsClick={() => { setShowPartners(false); setShowTermsOfService(true); updateURL('/terms'); }}
          onSignUpClick={() => { window.location.href = 'https://share.realpatients.com/register/'; }}
          bannerOffset={bannerOffset}
          footerProps={footerProps}
        />
      </div>
    );
  }

  // NSCLC Study Page
  if (showNsclcStudy) {
    return (
      <StudyPage onLogoClick={() => { resetViewsInternal(); updateURL('/'); }} />
    );
  }

  // GSK capabilities page
  if (showGSK) {
    return (
      <div className="App">
        <GSK />
      </div>
    );
  }

  // Demo Page
  if (showDemo) {
    return (
      <div className="App">
        <DemoPage />
      </div>
    );
  }

  // Patient Intel Page
  if (showPatientIntel) {
    return (
      <div className="App">
        <RebrandBanner
          onLearnMore={() => {}}
          onDismiss={handleBannerDismiss}
          dismissed={bannerDismissed}
        />
        <PatientIntel
          bannerOffset={bannerOffset}
          footerProps={footerProps}
          headerProps={{
            onLogoClick: () => { resetViewsInternal(); updateURL('/'); },
            onArticlesClick: () => { resetViewsInternal(); setShowArticles(true); updateURL('/articles'); },
            onPatientStoriesClick: () => { resetViewsInternal(); setShowPatientStories(true); updateURL('/patient-stories'); },
            onSignUpClick: () => { window.location.href = 'https://share.realpatients.com/register/'; },
            onAboutClick: () => { resetViewsInternal(); setShowOurStory(true); updateURL('/our-story'); },
            onPartnersClick: () => { resetViewsInternal(); setShowPartners(true); updateURL('/partners'); },
            onCommunityClick: () => { resetViewsInternal(); setShowPrototypeValueFirst(true); updateURL('/prototype/value-first'); },
          }}
        />
      </div>
    );
  }

  // Engagement / Working With Us Page
  if (showEngagement) {
    return (
      <div className="App">
        <RebrandBanner
          onLearnMore={() => {}}
          onDismiss={handleBannerDismiss}
          dismissed={bannerDismissed}
        />
        <EngagementPage
          bannerOffset={bannerOffset}
          headerProps={{
            onLogoClick: () => { resetViewsInternal(); updateURL('/'); },
            onArticlesClick: () => { resetViewsInternal(); setShowArticles(true); updateURL('/articles'); },
            onPatientStoriesClick: () => { resetViewsInternal(); setShowPatientStories(true); updateURL('/patient-stories'); },
            onSignUpClick: () => { window.location.href = 'https://share.realpatients.com/register/'; },
            onAboutClick: () => { resetViewsInternal(); setShowOurStory(true); updateURL('/our-story'); },
            onPartnersClick: () => { resetViewsInternal(); setShowPartners(true); updateURL('/partners'); },
            onCommunityClick: () => { resetViewsInternal(); setShowPrototypeValueFirst(true); updateURL('/prototype/value-first'); },
          }}
        />
      </div>
    );
  }

  // Privacy Policy Page
  if (showPrivacyPolicy) {
    return (
      <div className="App">
        <PrivacyPolicy
          onBack={() => { setShowPrivacyPolicy(false); updateURL('/'); }}
        />
        <Footer {...footerProps} />
      </div>
    );
  }

  // Terms of Service Page
  if (showTermsOfService) {
    return (
      <div className="App">
        <TermsOfService
          onBack={() => { setShowTermsOfService(false); updateURL('/'); }}
        />
        <Footer {...footerProps} />
      </div>
    );
  }

  // Prototype: Patient Signup Flow
  if (showPrototypeSignup) {
    return (
      <div className="App">
        <Header
          onLogoClick={() => { resetViewsInternal(); updateURL('/'); }}
          onArticlesClick={() => { resetViewsInternal(); setShowArticles(true); updateURL('/articles'); }}
          onPatientStoriesClick={() => { resetViewsInternal(); setShowPatientStories(true); updateURL('/patient-stories'); }}
          onSignUpClick={() => { window.location.href = 'https://share.realpatients.com/register/'; }}
          onAboutClick={() => { resetViewsInternal(); setShowOurStory(true); updateURL('/our-story'); }}
        />
        <PatientSignupFlow onBack={() => { resetViewsInternal(); updateURL('/'); }} />
        <Footer {...footerProps} />
      </div>
    );
  }

  // Prototype: Opportunity-Driven Flow
  if (showPrototypeOpportunity) {
    return (
      <div className="App">
        <Header
          onLogoClick={() => { resetViewsInternal(); updateURL('/'); }}
          onArticlesClick={() => { resetViewsInternal(); setShowArticles(true); updateURL('/articles'); }}
          onPatientStoriesClick={() => { resetViewsInternal(); setShowPatientStories(true); updateURL('/patient-stories'); }}
          onSignUpClick={() => { window.location.href = 'https://share.realpatients.com/register/'; }}
          onAboutClick={() => { resetViewsInternal(); setShowOurStory(true); updateURL('/our-story'); }}
        />
        <OpportunityFlow study={selectedStudy} onBack={() => { resetViewsInternal(); updateURL('/'); }} />
        <Footer {...footerProps} />
      </div>
    );
  }

  // Prototype: Value-First Flow
  if (showPrototypeValueFirst) {
    return (
      <div className="App">
        <Header
          onLogoClick={() => { resetViewsInternal(); updateURL('/'); }}
          onArticlesClick={() => { resetViewsInternal(); setShowArticles(true); updateURL('/articles'); }}
          onPatientStoriesClick={() => { resetViewsInternal(); setShowPatientStories(true); updateURL('/patient-stories'); }}
          onSignUpClick={() => { window.location.href = 'https://share.realpatients.com/register/'; }}
          onAboutClick={() => { resetViewsInternal(); setShowOurStory(true); updateURL('/our-story'); }}
        />
        <ValueFirstFlow onBack={() => { resetViewsInternal(); updateURL('/'); }} />
        <Footer {...footerProps} />
      </div>
    );
  }

  // Request a Project Page
  if (showRequestProject) {
    return (
      <div className="App">
        <Header
          onLogoClick={() => { resetViewsInternal(); updateURL('/'); }}
          onArticlesClick={() => { resetViewsInternal(); setShowArticles(true); updateURL('/articles'); }}
          onPatientStoriesClick={() => { resetViewsInternal(); setShowPatientStories(true); updateURL('/patient-stories'); }}
          onSignUpClick={() => { window.location.href = 'https://share.realpatients.com/register/'; }}
          onAboutClick={() => { resetViewsInternal(); setShowOurStory(true); updateURL('/our-story'); }}
        />
        <RequestProject onBack={() => { setShowRequestProject(false); updateURL('/'); }} />
        <Footer {...footerProps} />
      </div>
    );
  }

  // Blog Article Template Preview
  if (showBlogTemplate) {
    return (
      <div className="App">
        <button
          onClick={() => { setShowBlogTemplate(false); updateURL('/'); }}
          style={{
            position: 'fixed',
            top: '20px',
            left: '20px',
            zIndex: 1000,
            padding: '10px 20px',
            backgroundColor: '#fff',
            border: '2px solid #272726',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: '600'
          }}
        >
          ← Back to Home
        </button>
        <BlogArticle
          category="Lupus"
          title="Can You Die From Lupus? What 650 Real Patients Want You to Know"
          hook="The question haunts nearly every lupus patient at some point: Can this disease kill me? We asked 650 real lupus patients about their fears, experiences, and what they wish they'd known. Here's the truth—backed by their stories."
          authorName="Jen Horonjeff, PhD"
          authorBio="Co-founder of Real Patients and lifelong chronic illness patient. Jen has a PhD in health informatics and has spent over 15 years researching patient experiences and advocating for patient-centered healthcare."
          publishedDate="2025-01-20"
          readingTime="8 min read"
          takeaway1="While lupus can be life-threatening, most patients today live full lives with proper treatment—42% of surveyed patients report severe symptoms, but modern medicine has dramatically improved survival rates"
          takeaway2="The biggest dangers come from organ involvement (especially kidneys and heart), infections due to immunosuppression, and delayed diagnosis—not the disease itself in most cases"
          takeaway3="Fear of death is common and valid: 72 patients in our survey mentioned death-related fears, but many found that proper treatment and support transformed their outlook"
          takeaway4="Early diagnosis and consistent treatment are critical—some patients waited 10-20+ years for diagnosis, leading to preventable complications"
          takeaway5="You are not alone: connecting with other lupus patients and advocating for yourself can dramatically improve outcomes and quality of life"
          section1Title="Can lupus actually kill you?"
          section1Content="Let's address this directly: Yes, lupus can be fatal—but it's far less common than most newly diagnosed patients fear. Historically, lupus had a grim prognosis. In the 1950s, only 50% of patients survived five years. Today, thanks to advances in treatment, more than 90% of lupus patients live normal lifespans. The key factors are early diagnosis, consistent treatment, and monitoring for organ involvement."
          section1WhyMatters="Understanding the real risks—rather than spiraling into worst-case scenarios—empowers you to take control. As one patient in our survey shared: 'When you're faced with the fear of what could happen—including the possibility of death—it powerfully shapes your decisions about treatment. If you want to live, that fear becomes a driving force.'"
          section2Title="Who is most at risk?"
          section2Content="Lupus affects everyone differently. In our survey of 650 patients, 42% reported severe or very severe symptoms, while others manage milder forms. The patients at highest risk are those with lupus nephritis (kidney involvement), cardiac complications, or central nervous system involvement. African American, Hispanic, and Asian patients often experience more severe disease. Delayed diagnosis—sometimes 10, 15, or even 20+ years—also significantly increases risk by allowing organ damage to progress unchecked."
          section3Title="What makes lupus dangerous?"
          step1="Kidney damage (lupus nephritis): Affects up to 50% of lupus patients and is one of the leading causes of lupus-related death. One patient shared: 'As the years progressed I have kidney and lung problems. Cardiac issues that led to me having 3 stents put in.'"
          step2="Cardiovascular complications: Lupus increases heart attack and stroke risk. Inflammation can affect the heart lining (pericarditis) and blood vessels."
          step3="Infections: Immunosuppressant medications leave patients vulnerable. As one patient noted: 'When I got coronavirus it quickly escalated into Covid pneumonia. I desaturated and had to be admitted to the hospital for five days.'"
          step4="Blood clotting disorders: Antiphospholipid syndrome occurs in about 30% of lupus patients, increasing risk of dangerous blood clots."
          step5="Delayed diagnosis: Many patients see 3-4+ providers before getting answers. 'I wasn't given a diagnosis at that first visit, even though the blood work already pointed to what was happening. That delay added unnecessary months before I could begin treatment.'"
          section4Title="What patients say about facing mortality"
          example1Title="'I thought I was going to die'"
          example1Content="Multiple patients in our survey used these exact words when describing their diagnosis journey. One shared: 'When I was first diagnosed with Lupus, I was 15 years old. I felt validated and finally would get treatment for all the pain and fatigue I was experiencing. But learning what lupus was—learning that there is no known cause and no cure—was probably more debilitating than anything else.' Another recalled: 'They called my parents to come say their final goodbyes and doctors were crying when I woke up inexplicably. I should have died a few times and I'm still here.'"
          example2Title="Finding hope after fear"
          example2Content="Despite the fear, many patients found their way to hope. One patient who has lived with lupus for over 20 years shared: 'Before my Saphnelo infusions I rarely saw family and friends because all I would do is work full time and it caused so much pain. I wasn't able to become a nurse which was my dream. Now I have infusions and am able to see my friends and family and go back to school. I love my life more and look at the future with more hope and optimism than ever before.'"
          section5Title="The reality: hope vs. fear"
          pro1="90%+ of lupus patients now live normal lifespans with proper treatment"
          pro2="New treatments like Saphnelo and Benlysta are giving patients relief they never had before"
          pro3="Early diagnosis and aggressive treatment can prevent most serious complications"
          con1="Organ involvement (especially kidneys) remains a serious concern requiring vigilant monitoring"
          con2="Some patients experience treatment-resistant disease that requires ongoing adjustments"
          con3="The emotional toll of living with an unpredictable chronic illness is real and valid"
          qa1Question="Can you die from lupus?"
          qa1Answer="While lupus can be life-threatening, especially when it affects major organs like the kidneys or heart, most patients today live full, normal lifespans with proper treatment. Modern medicine has transformed lupus from a disease with 50% five-year survival in the 1950s to over 90% of patients living normal lifespans today. The key is early diagnosis, consistent treatment, and monitoring for complications."
          qa2Question="What is the life expectancy of someone with lupus?"
          qa2Answer="With modern treatment, most lupus patients have a normal or near-normal life expectancy. Studies show that 80-90% of people with lupus will live a normal lifespan. The main factors affecting life expectancy are organ involvement (especially kidneys), access to healthcare, treatment adherence, and how early the disease was diagnosed and treated."
          qa3Question="What are the warning signs that lupus is getting dangerous?"
          qa3Answer="Warning signs include blood in urine or foamy urine (kidney involvement), chest pain or shortness of breath (heart/lung involvement), severe headaches or confusion (CNS involvement), high fever, and rapid symptom progression. If you experience these, contact your rheumatologist immediately or go to the emergency room."
          term1="Lupus Nephritis"
          term1Definition="Inflammation of the kidneys caused by lupus. Affects up to 50% of lupus patients and is one of the most serious complications. Early detection through regular urine tests is critical."
          term2="Flare"
          term2Definition="A period when lupus symptoms suddenly worsen. Patients describe flares as unpredictable—triggered by stress, sun exposure, infections, or sometimes nothing identifiable. Learning your personal triggers helps manage the disease."
          term3="ANA Test"
          term3Definition="Antinuclear Antibody test—the most common blood test used to help diagnose lupus. A positive ANA doesn't confirm lupus (many healthy people have positive ANAs), but it's often the first step in diagnosis."
          faq1Question="What actually kills lupus patients?"
          faq1Answer="The leading causes of death in lupus patients are infections (due to immunosuppression from both the disease and treatments), cardiovascular disease (lupus significantly increases heart attack and stroke risk), and kidney failure (when lupus nephritis progresses). This is why regular monitoring and treating complications early is so important."
          faq2Question="How do I know if my lupus is serious?"
          faq2Answer="Severity varies greatly between patients. Signs of more serious disease include kidney involvement (protein in urine, swelling), heart or lung symptoms, central nervous system involvement (severe headaches, seizures, cognitive changes), and frequent severe flares. Regular bloodwork and check-ups with your rheumatologist help catch problems early. In our survey, 42% of patients reported severe or very severe symptoms."
          faq3Question="Can lupus go into remission?"
          faq3Answer="Yes, lupus can go into remission—a period of little to no disease activity. Some patients achieve long-term remission with treatment, though the disease can flare again. One patient shared: 'After about two years, I was able to gradually taper off Plaquenil, and now I manage occasional joint pain with over-the-counter medications like ibuprofen. The flares are rare.'"
          faq4Question="What should I do if I'm scared about dying from lupus?"
          faq4Answer="Your fear is valid—many lupus patients share it. First, know that most lupus patients live full lives with proper care. Second, be proactive: attend all appointments, take medications as prescribed, and monitor for warning signs. Third, seek support—whether from a therapist, support group, or other patients. One patient advised: 'My faith has become the strongest foundation of my coping strategy... maintaining a hopeful mindset has been essential.'"
          ctaHeadline="Your experience matters"
          ctaDescription="650 lupus patients shared their stories to help others like you. Now you can contribute your voice to research that improves care for everyone."
          ctaButtonText="Share Your Experience"
          ctaButtonUrl="/signup"
          onCtaClick={() => { window.location.href = 'https://share.realpatients.com/register/'; }}
          resource1Title="Lupus Foundation of America"
          resource1Url="https://www.lupus.org"
          resource2Title="Understanding Lupus Nephritis"
          resource2Url="https://www.kidney.org/atoz/content/lupus"
          resource3Title="Find a Rheumatologist"
          resource3Url="https://www.rheumatology.org/Find-a-Rheumatologist"
        />
        <Footer {...footerProps} />
      </div>
    );
  }

  // Individual Article View
  if (selectedArticle) {
    // Check if this is the "Can You Die From Lupus" article
    const isLupusDeathArticle = selectedArticle.title && selectedArticle.title.includes('Can You Die From Lupus');

    // Check if this is a narcolepsy article with full content
    const narcolepsyFullArticle = selectedArticle.hasFullArticle && selectedArticle.condition === 'Narcolepsy'
      ? narcolepsyArticles.find(a => a.id === selectedArticle.id)
      : null;

    // Check if this is a lupus article with full content
    const lupusFullArticle = selectedArticle.hasFullArticle && selectedArticle.condition === 'Lupus'
      ? lupusArticles.find(a => a.id === selectedArticle.id)
      : null;

    return (
      <div className="App">
        <Header
          onLogoClick={() => { resetViewsInternal(); updateURL('/'); }}
          onArticlesClick={() => { resetViewsInternal(); setShowArticles(true); updateURL('/articles'); }}
          onPatientStoriesClick={() => { resetViewsInternal(); setShowPatientStories(true); updateURL('/patient-stories'); }}
          onSignUpClick={() => { window.location.href = 'https://share.realpatients.com/register/'; }}
          onCommunityClick={() => { resetViewsInternal(); setShowPrototypeValueFirst(true); updateURL('/prototype/value-first'); }}
          onAboutClick={() => { resetViewsInternal(); setShowOurStory(true); updateURL('/our-story'); }}
        />
        <div style={{ height: '80px' }} /> {/* Spacer for fixed header */}
        {narcolepsyFullArticle ? (
          <BlogArticle
            category={narcolepsyFullArticle.category}
            title={narcolepsyFullArticle.title}
            hook={narcolepsyFullArticle.hook}
            authorName={narcolepsyFullArticle.authorName}
            authorBio={narcolepsyFullArticle.authorBio}
            publishedDate={narcolepsyFullArticle.publishedDate}
            readingTime={narcolepsyFullArticle.readingTime}
            takeaway1={narcolepsyFullArticle.takeaway1}
            takeaway2={narcolepsyFullArticle.takeaway2}
            takeaway3={narcolepsyFullArticle.takeaway3}
            takeaway4={narcolepsyFullArticle.takeaway4}
            takeaway5={narcolepsyFullArticle.takeaway5}
            section1Title={narcolepsyFullArticle.section1Title}
            section1Content={narcolepsyFullArticle.section1Content}
            section1WhyMatters={narcolepsyFullArticle.section1WhyMatters}
            section2Title={narcolepsyFullArticle.section2Title}
            section2Content={narcolepsyFullArticle.section2Content}
            section3Title={narcolepsyFullArticle.section3Title}
            step1={narcolepsyFullArticle.step1}
            step2={narcolepsyFullArticle.step2}
            step3={narcolepsyFullArticle.step3}
            step4={narcolepsyFullArticle.step4}
            step5={narcolepsyFullArticle.step5}
            section4Title={narcolepsyFullArticle.section4Title}
            example1Title={narcolepsyFullArticle.example1Title}
            example1Content={narcolepsyFullArticle.example1Content}
            example2Title={narcolepsyFullArticle.example2Title}
            example2Content={narcolepsyFullArticle.example2Content}
            section5Title={narcolepsyFullArticle.section5Title}
            pro1={narcolepsyFullArticle.pro1}
            pro2={narcolepsyFullArticle.pro2}
            pro3={narcolepsyFullArticle.pro3}
            con1={narcolepsyFullArticle.con1}
            con2={narcolepsyFullArticle.con2}
            con3={narcolepsyFullArticle.con3}
            qa1Question={narcolepsyFullArticle.qa1Question}
            qa1Answer={narcolepsyFullArticle.qa1Answer}
            qa2Question={narcolepsyFullArticle.qa2Question}
            qa2Answer={narcolepsyFullArticle.qa2Answer}
            qa3Question={narcolepsyFullArticle.qa3Question}
            qa3Answer={narcolepsyFullArticle.qa3Answer}
            term1={narcolepsyFullArticle.term1}
            term1Definition={narcolepsyFullArticle.term1Definition}
            term2={narcolepsyFullArticle.term2}
            term2Definition={narcolepsyFullArticle.term2Definition}
            term3={narcolepsyFullArticle.term3}
            term3Definition={narcolepsyFullArticle.term3Definition}
            faq1Question={narcolepsyFullArticle.faq1Question}
            faq1Answer={narcolepsyFullArticle.faq1Answer}
            faq2Question={narcolepsyFullArticle.faq2Question}
            faq2Answer={narcolepsyFullArticle.faq2Answer}
            faq3Question={narcolepsyFullArticle.faq3Question}
            faq3Answer={narcolepsyFullArticle.faq3Answer}
            faq4Question={narcolepsyFullArticle.faq4Question}
            faq4Answer={narcolepsyFullArticle.faq4Answer}
            ctaHeadline={narcolepsyFullArticle.ctaHeadline}
            ctaDescription={narcolepsyFullArticle.ctaDescription}
            ctaButtonText={narcolepsyFullArticle.ctaButtonText}
            ctaButtonUrl={narcolepsyFullArticle.ctaButtonUrl}
            onCtaClick={() => { window.location.href = 'https://share.realpatients.com/register/'; }}
            communityQuestion={getCommunityDataForArticle('Narcolepsy', narcolepsyFullArticle.category).question}
            communityAnswers={getCommunityDataForArticle('Narcolepsy', narcolepsyFullArticle.category).answers}
            onCommunityClick={() => { resetViewsInternal(); setShowPrototypeValueFirst(true); updateURL('/prototype/value-first'); }}
            resource1Title={narcolepsyFullArticle.resource1Title}
            resource1Url={narcolepsyFullArticle.resource1Url}
            resource2Title={narcolepsyFullArticle.resource2Title}
            resource2Url={narcolepsyFullArticle.resource2Url}
            resource3Title={narcolepsyFullArticle.resource3Title}
            resource3Url={narcolepsyFullArticle.resource3Url}
          />
        ) : lupusFullArticle ? (
          <BlogArticle
            category={lupusFullArticle.category}
            title={lupusFullArticle.title}
            hook={lupusFullArticle.hook}
            authorName={lupusFullArticle.authorName}
            authorBio={lupusFullArticle.authorBio}
            publishedDate={lupusFullArticle.publishedDate}
            readingTime={lupusFullArticle.readingTime}
            takeaway1={lupusFullArticle.takeaway1}
            takeaway2={lupusFullArticle.takeaway2}
            takeaway3={lupusFullArticle.takeaway3}
            takeaway4={lupusFullArticle.takeaway4}
            takeaway5={lupusFullArticle.takeaway5}
            section1Title={lupusFullArticle.section1Title}
            section1Content={lupusFullArticle.section1Content}
            section1WhyMatters={lupusFullArticle.section1WhyMatters}
            section2Title={lupusFullArticle.section2Title}
            section2Content={lupusFullArticle.section2Content}
            section3Title={lupusFullArticle.section3Title}
            step1={lupusFullArticle.step1}
            step2={lupusFullArticle.step2}
            step3={lupusFullArticle.step3}
            step4={lupusFullArticle.step4}
            step5={lupusFullArticle.step5}
            section4Title={lupusFullArticle.section4Title}
            example1Title={lupusFullArticle.example1Title}
            example1Content={lupusFullArticle.example1Content}
            example2Title={lupusFullArticle.example2Title}
            example2Content={lupusFullArticle.example2Content}
            section5Title={lupusFullArticle.section5Title}
            pro1={lupusFullArticle.pro1}
            pro2={lupusFullArticle.pro2}
            pro3={lupusFullArticle.pro3}
            con1={lupusFullArticle.con1}
            con2={lupusFullArticle.con2}
            con3={lupusFullArticle.con3}
            qa1Question={lupusFullArticle.qa1Question}
            qa1Answer={lupusFullArticle.qa1Answer}
            qa2Question={lupusFullArticle.qa2Question}
            qa2Answer={lupusFullArticle.qa2Answer}
            qa3Question={lupusFullArticle.qa3Question}
            qa3Answer={lupusFullArticle.qa3Answer}
            term1={lupusFullArticle.term1}
            term1Definition={lupusFullArticle.term1Definition}
            term2={lupusFullArticle.term2}
            term2Definition={lupusFullArticle.term2Definition}
            term3={lupusFullArticle.term3}
            term3Definition={lupusFullArticle.term3Definition}
            faq1Question={lupusFullArticle.faq1Question}
            faq1Answer={lupusFullArticle.faq1Answer}
            faq2Question={lupusFullArticle.faq2Question}
            faq2Answer={lupusFullArticle.faq2Answer}
            faq3Question={lupusFullArticle.faq3Question}
            faq3Answer={lupusFullArticle.faq3Answer}
            faq4Question={lupusFullArticle.faq4Question}
            faq4Answer={lupusFullArticle.faq4Answer}
            ctaHeadline={lupusFullArticle.ctaHeadline}
            ctaDescription={lupusFullArticle.ctaDescription}
            ctaButtonText={lupusFullArticle.ctaButtonText}
            ctaButtonUrl={lupusFullArticle.ctaButtonUrl}
            onCtaClick={() => { window.location.href = 'https://share.realpatients.com/register/'; }}
            communityQuestion={getCommunityDataForArticle('Lupus', lupusFullArticle.category).question}
            communityAnswers={getCommunityDataForArticle('Lupus', lupusFullArticle.category).answers}
            onCommunityClick={() => { resetViewsInternal(); setShowPrototypeValueFirst(true); updateURL('/prototype/value-first'); }}
            resource1Title={lupusFullArticle.resource1Title}
            resource1Url={lupusFullArticle.resource1Url}
            resource2Title={lupusFullArticle.resource2Title}
            resource2Url={lupusFullArticle.resource2Url}
            resource3Title={lupusFullArticle.resource3Title}
            resource3Url={lupusFullArticle.resource3Url}
          />
        ) : isLupusDeathArticle ? (
          <BlogArticle
            category="Lupus"
            title="Can You Die From Lupus? What 650 Real Patients Want You to Know"
            hook="The question haunts nearly every lupus patient at some point: Can this disease kill me? We asked 650 real lupus patients about their fears, experiences, and what they wish they'd known. Here's the truth—backed by their stories."
            authorName="Jen Horonjeff, PhD"
            authorBio="Co-founder of Real Patients and lifelong chronic illness patient. Jen has a PhD in health informatics and has spent over 15 years researching patient experiences and advocating for patient-centered healthcare."
            publishedDate="2025-01-20"
            readingTime="8 min read"
            takeaway1="While lupus can be life-threatening, most patients today live full lives with proper treatment—42% of surveyed patients report severe symptoms, but modern medicine has dramatically improved survival rates"
            takeaway2="The biggest dangers come from organ involvement (especially kidneys and heart), infections due to immunosuppression, and delayed diagnosis—not the disease itself in most cases"
            takeaway3="Fear of death is common and valid: 72 patients in our survey mentioned death-related fears, but many found that proper treatment and support transformed their outlook"
            takeaway4="Early diagnosis and consistent treatment are critical—some patients waited 10-20+ years for diagnosis, leading to preventable complications"
            takeaway5="You are not alone: connecting with other lupus patients and advocating for yourself can dramatically improve outcomes and quality of life"
            section1Title="Can lupus actually kill you?"
            section1Content="Let's address this directly: Yes, lupus can be fatal—but it's far less common than most newly diagnosed patients fear. Historically, lupus had a grim prognosis. In the 1950s, only 50% of patients survived five years. Today, thanks to advances in treatment, more than 90% of lupus patients live normal lifespans. The key factors are early diagnosis, consistent treatment, and monitoring for organ involvement."
            section1WhyMatters="Understanding the real risks—rather than spiraling into worst-case scenarios—empowers you to take control. As one patient in our survey shared: 'When you're faced with the fear of what could happen—including the possibility of death—it powerfully shapes your decisions about treatment. If you want to live, that fear becomes a driving force.'"
            section2Title="Who is most at risk?"
            section2Content="Lupus affects everyone differently. In our survey of 650 patients, 42% reported severe or very severe symptoms, while others manage milder forms. The patients at highest risk are those with lupus nephritis (kidney involvement), cardiac complications, or central nervous system involvement. African American, Hispanic, and Asian patients often experience more severe disease. Delayed diagnosis—sometimes 10, 15, or even 20+ years—also significantly increases risk by allowing organ damage to progress unchecked."
            section3Title="What makes lupus dangerous?"
            step1="Kidney damage (lupus nephritis): Affects up to 50% of lupus patients and is one of the leading causes of lupus-related death. One patient shared: 'As the years progressed I have kidney and lung problems. Cardiac issues that led to me having 3 stents put in.'"
            step2="Cardiovascular complications: Lupus increases heart attack and stroke risk. Inflammation can affect the heart lining (pericarditis) and blood vessels."
            step3="Infections: Immunosuppressant medications leave patients vulnerable. As one patient noted: 'When I got coronavirus it quickly escalated into Covid pneumonia. I desaturated and had to be admitted to the hospital for five days.'"
            step4="Blood clotting disorders: Antiphospholipid syndrome occurs in about 30% of lupus patients, increasing risk of dangerous blood clots."
            step5="Delayed diagnosis: Many patients see 3-4+ providers before getting answers. 'I wasn't given a diagnosis at that first visit, even though the blood work already pointed to what was happening. That delay added unnecessary months before I could begin treatment.'"
            section4Title="What patients say about facing mortality"
            example1Title="'I thought I was going to die'"
            example1Content="Multiple patients in our survey used these exact words when describing their diagnosis journey. One shared: 'When I was first diagnosed with Lupus, I was 15 years old. I felt validated and finally would get treatment for all the pain and fatigue I was experiencing. But learning what lupus was—learning that there is no known cause and no cure—was probably more debilitating than anything else.' Another recalled: 'They called my parents to come say their final goodbyes and doctors were crying when I woke up inexplicably. I should have died a few times and I'm still here.'"
            example2Title="Finding hope after fear"
            example2Content="Despite the fear, many patients found their way to hope. One patient who has lived with lupus for over 20 years shared: 'Before my Saphnelo infusions I rarely saw family and friends because all I would do is work full time and it caused so much pain. I wasn't able to become a nurse which was my dream. Now I have infusions and am able to see my friends and family and go back to school. I love my life more and look at the future with more hope and optimism than ever before.'"
            section5Title="The reality: hope vs. fear"
            pro1="90%+ of lupus patients now live normal lifespans with proper treatment"
            pro2="New treatments like Saphnelo and Benlysta are giving patients relief they never had before"
            pro3="Early diagnosis and aggressive treatment can prevent most serious complications"
            con1="Organ involvement (especially kidneys) remains a serious concern requiring vigilant monitoring"
            con2="Some patients experience treatment-resistant disease that requires ongoing adjustments"
            con3="The emotional toll of living with an unpredictable chronic illness is real and valid"
            qa1Question="Can you die from lupus?"
            qa1Answer="While lupus can be life-threatening, especially when it affects major organs like the kidneys or heart, most patients today live full, normal lifespans with proper treatment. Modern medicine has transformed lupus from a disease with 50% five-year survival in the 1950s to over 90% of patients living normal lifespans today. The key is early diagnosis, consistent treatment, and monitoring for complications."
            qa2Question="What is the life expectancy of someone with lupus?"
            qa2Answer="With modern treatment, most lupus patients have a normal or near-normal life expectancy. Studies show that 80-90% of people with lupus will live a normal lifespan. The main factors affecting life expectancy are organ involvement (especially kidneys), access to healthcare, treatment adherence, and how early the disease was diagnosed and treated."
            qa3Question="What are the warning signs that lupus is getting dangerous?"
            qa3Answer="Warning signs include blood in urine or foamy urine (kidney involvement), chest pain or shortness of breath (heart/lung involvement), severe headaches or confusion (CNS involvement), high fever, and rapid symptom progression. If you experience these, contact your rheumatologist immediately or go to the emergency room."
            term1="Lupus Nephritis"
            term1Definition="Inflammation of the kidneys caused by lupus. Affects up to 50% of lupus patients and is one of the most serious complications. Early detection through regular urine tests is critical."
            term2="Flare"
            term2Definition="A period when lupus symptoms suddenly worsen. Patients describe flares as unpredictable—triggered by stress, sun exposure, infections, or sometimes nothing identifiable. Learning your personal triggers helps manage the disease."
            term3="ANA Test"
            term3Definition="Antinuclear Antibody test—the most common blood test used to help diagnose lupus. A positive ANA doesn't confirm lupus (many healthy people have positive ANAs), but it's often the first step in diagnosis."
            faq1Question="What actually kills lupus patients?"
            faq1Answer="The leading causes of death in lupus patients are infections (due to immunosuppression from both the disease and treatments), cardiovascular disease (lupus significantly increases heart attack and stroke risk), and kidney failure (when lupus nephritis progresses). This is why regular monitoring and treating complications early is so important."
            faq2Question="How do I know if my lupus is serious?"
            faq2Answer="Severity varies greatly between patients. Signs of more serious disease include kidney involvement (protein in urine, swelling), heart or lung symptoms, central nervous system involvement (severe headaches, seizures, cognitive changes), and frequent severe flares. Regular bloodwork and check-ups with your rheumatologist help catch problems early. In our survey, 42% of patients reported severe or very severe symptoms."
            faq3Question="Can lupus go into remission?"
            faq3Answer="Yes, lupus can go into remission—a period of little to no disease activity. Some patients achieve long-term remission with treatment, though the disease can flare again. One patient shared: 'After about two years, I was able to gradually taper off Plaquenil, and now I manage occasional joint pain with over-the-counter medications like ibuprofen. The flares are rare.'"
            faq4Question="What should I do if I'm scared about dying from lupus?"
            faq4Answer="Your fear is valid—many lupus patients share it. First, know that most lupus patients live full lives with proper care. Second, be proactive: attend all appointments, take medications as prescribed, and monitor for warning signs. Third, seek support—whether from a therapist, support group, or other patients. One patient advised: 'My faith has become the strongest foundation of my coping strategy... maintaining a hopeful mindset has been essential.'"
            ctaHeadline="Your experience matters"
            ctaDescription="650 lupus patients shared their stories to help others like you. Now you can contribute your voice to research that improves care for everyone."
            ctaButtonText="Share Your Experience"
            ctaButtonUrl="/signup"
            onCtaClick={() => { window.location.href = 'https://share.realpatients.com/register/'; }}
            communityQuestion={getCommunityDataForArticle('Lupus', 'Living with Lupus').question}
            communityAnswers={getCommunityDataForArticle('Lupus', 'Living with Lupus').answers}
            onCommunityClick={() => { resetViewsInternal(); setShowPrototypeValueFirst(true); updateURL('/prototype/value-first'); }}
            resource1Title="Lupus Foundation of America"
            resource1Url="https://www.lupus.org"
            resource2Title="Understanding Lupus Nephritis"
            resource2Url="https://www.kidney.org/atoz/content/lupus"
            resource3Title="Find a Rheumatologist"
            resource3Url="https://www.rheumatology.org/Find-a-Rheumatologist"
          />
        ) : (
          <BlogArticle
            category={selectedArticle.condition || 'Health'}
            title={selectedArticle.title}
            hook={selectedArticle.excerpt}
            authorName="Jen Horonjeff, PhD"
            authorBio="Co-founder of Real Patients and lifelong chronic illness patient."
            publishedDate="2025-01-20"
            readingTime={selectedArticle.readTime}
            onCtaClick={() => { window.location.href = 'https://share.realpatients.com/register/'; }}
            communityQuestion={getCommunityDataForArticle(selectedArticle.condition || 'default', selectedArticle.category || '').question}
            communityAnswers={getCommunityDataForArticle(selectedArticle.condition || 'default', selectedArticle.category || '').answers}
            onCommunityClick={() => { resetViewsInternal(); setShowPrototypeValueFirst(true); updateURL('/prototype/value-first'); }}
          />
        )}
        <Footer {...footerProps} />
      </div>
    );
  }

  // Condition-specific Articles Page
  if (selectedCondition) {
    const conditionInfo = conditionsData[selectedCondition] || { color: '#f15b41' };
    const conditionArticles = articlesByCondition[selectedCondition] || [];
    return (
      <div className="App">
        <Header
          onLogoClick={() => { resetViewsInternal(); updateURL('/'); }}
          onArticlesClick={() => { resetViewsInternal(); setShowArticles(true); updateURL('/articles'); }}
          onPatientStoriesClick={() => { resetViewsInternal(); setShowPatientStories(true); updateURL('/patient-stories'); }}
          onSignUpClick={() => { window.location.href = 'https://share.realpatients.com/register/'; }}
          onAboutClick={() => { resetViewsInternal(); setShowOurStory(true); updateURL('/our-story'); }}
        />
        <div style={{ height: '80px' }} /> {/* Spacer for fixed header */}
        <ConditionArticles
          condition={selectedCondition}
          conditionColor={conditionInfo.color}
          articles={conditionArticles}
          onBack={() => {
            setSelectedCondition(null);
            setShowArticles(true);
            updateURL('/articles');
          }}
          onArticleClick={(article) => {
            setSelectedArticle({ ...article, condition: selectedCondition });
            updateURL(`/condition/${encodeURIComponent(selectedCondition)}/${article.id}`);
          }}
          onCommunityClick={() => { resetViewsInternal(); setShowPrototypeValueFirst(true); updateURL('/prototype/value-first'); }}
        />
        <Footer {...footerProps} />
      </div>
    );
  }

  // Articles Landing Page
  if (showArticles) {
    return (
      <div className="App">
        <Header
          onLogoClick={() => { resetViewsInternal(); updateURL('/'); }}
          onArticlesClick={() => { resetViewsInternal(); setShowArticles(true); updateURL('/articles'); }}
          onPatientStoriesClick={() => { resetViewsInternal(); setShowPatientStories(true); updateURL('/patient-stories'); }}
          onSignUpClick={() => { window.location.href = 'https://share.realpatients.com/register/'; }}
          onAboutClick={() => { resetViewsInternal(); setShowOurStory(true); updateURL('/our-story'); }}
        />
        <div style={{ height: '80px' }} /> {/* Spacer for fixed header */}
        <ArticlesLanding
          onConditionClick={(condition) => {
            setShowArticles(false);
            setSelectedCondition(condition);
            updateURL(`/condition/${encodeURIComponent(condition)}`);
          }}
          onArticleClick={(article) => {
            setShowArticles(false);
            setSelectedArticle(article);
            if (article.condition) {
              updateURL(`/condition/${encodeURIComponent(article.condition)}/${article.id}`);
            }
          }}
        />
        <Footer {...footerProps} />
      </div>
    );
  }

  if (showPatientStories) {
    return (
      <div className="App">
        <Header
          onLogoClick={() => { resetViewsInternal(); updateURL('/'); }}
          onArticlesClick={() => { resetViewsInternal(); setShowArticles(true); updateURL('/articles'); }}
          onPatientStoriesClick={() => { resetViewsInternal(); setShowPatientStories(true); updateURL('/patient-stories'); }}
          onSignUpClick={() => { window.location.href = 'https://share.realpatients.com/register/'; }}
          onAboutClick={() => { resetViewsInternal(); setShowOurStory(true); updateURL('/our-story'); }}
        />
        <div style={{ height: '80px' }} /> {/* Spacer for fixed header */}
        <PatientStories onClose={() => { setShowPatientStories(false); updateURL('/'); }} />
      </div>
    );
  }

  if (showQuiz) {
    return (
      <div className="App">
        <button
          onClick={() => { setShowQuiz(false); updateURL('/'); }}
          style={{
            position: 'fixed',
            top: '20px',
            left: '20px',
            zIndex: 1000,
            padding: '10px 20px',
            backgroundColor: '#fff',
            border: '2px solid #272726',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: '600'
          }}
        >
          ← Back to Home
        </button>
        <QuizExperience />
      </div>
    );
  }

  if (showAboutApproach) {
    return (
      <div className="App">
        <button
          onClick={() => { setShowAboutApproach(false); updateURL('/'); }}
          style={{
            position: 'fixed',
            top: '20px',
            left: '20px',
            zIndex: 1000,
            padding: '10px 20px',
            backgroundColor: '#fff',
            border: '2px solid #272726',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: '600',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
          }}
        >
          ← Back to Home
        </button>
        <AboutApproach
          onCtaClick={() => {
            setShowAboutApproach(false);
            setShowQuiz(true);
            updateURL('/quiz');
          }}
          onSecondaryClick={() => {
            setShowAboutApproach(false);
            setShowPatientStories(true);
            updateURL('/patient-stories');
          }}
        />
        <Footer {...footerProps} />
      </div>
    );
  }

  // Homepage
  return (
    <div className="App">
      <SEOHead />
      <RebrandBanner
        onLearnMore={() => { resetViewsInternal(); setShowOurStory(true); updateURL('/our-story'); }}
        onDismiss={handleBannerDismiss}
        dismissed={bannerDismissed}
      />
      <Header
        onLogoClick={() => { resetViewsInternal(); updateURL('/'); }}
        onArticlesClick={() => { resetViewsInternal(); setShowArticles(true); updateURL('/articles'); }}
        onPatientStoriesClick={() => { resetViewsInternal(); setShowPatientStories(true); updateURL('/patient-stories'); }}
        onSignUpClick={() => { window.location.href = 'https://share.realpatients.com/register/'; }}
        onCommunityClick={() => { resetViewsInternal(); setShowPrototypeValueFirst(true); updateURL('/prototype/value-first'); }}
        onPartnersClick={() => { resetViewsInternal(); setShowPartners(true); updateURL('/partners'); }}
        onAboutClick={() => { resetViewsInternal(); setShowOurStory(true); updateURL('/our-story'); }}
        bannerOffset={bannerOffset}
      />
      <HeroRotating
        onCtaClick={() => { resetViewsInternal(); setShowPrototypeValueFirst(true); updateURL('/prototype/value-first'); }}
        ctaText="See What Patients Are Saying"
        onSecondaryCtaClick={() => { document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' }); }}
      />
      <StatsSection />
      <ConditionsTicker />

      {/* Brushstroke divider - top */}
      <div style={{
        width: '100%',
        overflow: 'hidden',
        lineHeight: 0,
        backgroundColor: '#fff'
      }}>
        <svg
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
          style={{
            width: '100%',
            height: '60px',
            display: 'block'
          }}
        >
          <defs>
            <linearGradient id="brushGradientTop" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="rgba(250, 190, 192, 0.6)" />
              <stop offset="35%" stopColor="rgba(247, 192, 138, 0.5)" />
              <stop offset="70%" stopColor="rgba(251, 244, 188, 0.4)" />
              <stop offset="100%" stopColor="rgba(247, 192, 138, 0.3)" />
            </linearGradient>
          </defs>
          <path
            d="M0,60 Q150,20 300,45 T600,30 T900,50 T1200,35 L1200,120 L0,120 Z"
            fill="url(#brushGradientTop)"
          />
          <path
            d="M0,75 Q200,40 400,60 T800,45 T1200,55 L1200,120 L0,120 Z"
            fill="rgba(250, 190, 192, 0.25)"
          />
        </svg>
      </div>

      {/* The Invitation - emotional lead-in section */}
      <section
        style={{
          backgroundColor: '#ffffff',
          padding: '80px 24px 100px',
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Subtle decorative elements */}
        <div
          style={{
            position: 'absolute',
            top: '10%',
            left: '5%',
            width: '200px',
            height: '200px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(250, 190, 192, 0.15) 0%, transparent 70%)',
            pointerEvents: 'none'
          }}
        />
        <div
          style={{
            position: 'absolute',
            bottom: '15%',
            right: '8%',
            width: '180px',
            height: '180px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(247, 192, 138, 0.12) 0%, transparent 70%)',
            pointerEvents: 'none'
          }}
        />

        <div style={{ maxWidth: '800px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
          <p
            style={{
              fontFamily: '"Source Serif Pro", Georgia, serif',
              fontSize: 'clamp(28px, 5vw, 40px)',
              fontWeight: '400',
              color: '#111111',
              lineHeight: '1.5',
              margin: '0 0 40px'
            }}
          >
            Imagine if healthcare organizations truly{' '}
            <span style={{ position: 'relative', display: 'inline-block' }}>
              <span
                style={{
                  position: 'absolute',
                  left: '-2%',
                  right: '-2%',
                  bottom: '5%',
                  height: '35%',
                  background: 'linear-gradient(90deg, rgba(235, 160, 155, 0.7) 0%, rgba(245, 185, 165, 0.65) 40%, rgba(250, 200, 160, 0.6) 70%, rgba(245, 215, 170, 0.5) 100%)',
                  transform: 'skewX(-1deg)',
                  zIndex: 0,
                  borderRadius: '2px'
                }}
              />
              <span style={{ position: 'relative', zIndex: 1 }}>listened to patients</span>
            </span>.
          </p>
          <p
            style={{
              fontSize: 'clamp(18px, 2.5vw, 22px)',
              color: '#4A4A4A',
              lineHeight: '1.8',
              margin: '0 0 28px'
            }}
          >
            At <strong style={{ color: '#111111' }}>Real Patients™</strong>, we bring your experiences directly into the decisions that shape healthcare.
          </p>
          <p
            style={{
              fontSize: 'clamp(18px, 2.5vw, 22px)',
              color: '#4A4A4A',
              lineHeight: '1.8',
              margin: '0'
            }}
          >
            And you{' '}
            <span style={{ position: 'relative', display: 'inline-block' }}>
              <span
                style={{
                  position: 'absolute',
                  left: '-2%',
                  right: '-2%',
                  bottom: '5%',
                  height: '35%',
                  background: 'linear-gradient(90deg, rgba(235, 160, 155, 0.7) 0%, rgba(245, 185, 165, 0.65) 40%, rgba(250, 200, 160, 0.6) 70%, rgba(245, 215, 170, 0.5) 100%)',
                  transform: 'skewX(-1deg)',
                  zIndex: 0,
                  borderRadius: '2px'
                }}
              />
              <span style={{ position: 'relative', zIndex: 1 }}>stay in control</span>
            </span>
            {' '}of what you share, every step of the way.
          </p>
        </div>
      </section>

      {/* Brushstroke divider - bottom */}
      <div style={{
        width: '100%',
        overflow: 'hidden',
        lineHeight: 0,
        backgroundColor: '#fff',
        transform: 'rotate(180deg)'
      }}>
        <svg
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
          style={{
            width: '100%',
            height: '60px',
            display: 'block'
          }}
        >
          <defs>
            <linearGradient id="brushGradientBottom" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="rgba(247, 192, 138, 0.3)" />
              <stop offset="30%" stopColor="rgba(251, 244, 188, 0.4)" />
              <stop offset="65%" stopColor="rgba(247, 192, 138, 0.5)" />
              <stop offset="100%" stopColor="rgba(250, 190, 192, 0.6)" />
            </linearGradient>
          </defs>
          <path
            d="M0,50 Q200,25 400,55 T800,35 T1200,45 L1200,120 L0,120 Z"
            fill="url(#brushGradientBottom)"
          />
          <path
            d="M0,65 Q300,35 600,55 T1200,40 L1200,120 L0,120 Z"
            fill="rgba(250, 190, 192, 0.2)"
          />
        </svg>
      </div>

      <div id="how-it-works">
        <HowItWorksJourney />
      </div>
      <FoundersSection />
      <CredibilitySection onApproachClick={() => { setShowOurStory(true); updateURL('/our-story'); }} />
      {/* <RealStories /> */}
      <PressLogos />
      <FAQ onReadStoryClick={() => { resetViewsInternal(); setShowOurStory(true); updateURL('/our-story'); }} />

      {/* Gradient fade into closing section */}
      <div style={{
        height: '60px',
        background: 'linear-gradient(180deg, #faf9f9 0%, #a8c5d9 100%)'
      }} />

      {/* Final CTA - closing section */}
      <section
        style={{
          backgroundColor: '#a8c5d9',
          padding: '100px 24px',
          textAlign: 'center'
        }}
      >
        <div style={{ maxWidth: '700px', margin: '0 auto' }}>
          <h2
            style={{
              fontFamily: '"Source Serif Pro", Georgia, serif',
              fontSize: 'clamp(28px, 5vw, 42px)',
              fontWeight: '600',
              color: '#1a1a1a',
              lineHeight: '1.3',
              margin: '0 0 16px'
            }}
          >
            Real insight comes from{' '}
            <span style={{ position: 'relative', display: 'inline-block' }}>
              <span
                style={{
                  position: 'absolute',
                  left: '-2%',
                  right: '-2%',
                  bottom: '5%',
                  height: '35%',
                  background: 'linear-gradient(90deg, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0.5) 100%)',
                  transform: 'skewX(-1deg)',
                  zIndex: 0,
                  borderRadius: '2px'
                }}
              />
              <span style={{ position: 'relative', zIndex: 1 }}>real experiences</span>
            </span>.
          </h2>
          <p
            style={{
              fontSize: '20px',
              color: '#2a2a2a',
              lineHeight: '1.6',
              margin: '0 0 40px'
            }}
          >
            Help bring yours into the conversation.
          </p>
          <button
            onClick={() => { window.location.href = 'https://share.realpatients.com/register/'; }}
            style={{
              fontFamily: 'inherit',
              fontSize: '18px',
              fontWeight: '600',
              color: '#ffffff',
              backgroundColor: '#385cbc',
              border: 'none',
              borderRadius: '30px',
              padding: '18px 40px',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              boxShadow: '0 4px 14px rgba(0, 0, 0, 0.15)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 14px rgba(0, 0, 0, 0.15)';
            }}
          >
            Share your experience
          </button>
        </div>
      </section>

      <Footer {...footerProps} />
    </div>
  );
}

export default App;
